import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';

import {
  actions as competitionsActions,
  selectors as competitionsSelectors,
} from '../../../store/competitions';

import { CompetitionPropType } from '../../common/types';

import Spinner from '../../common/Spinner';
import Markdown from '../../common/Markdown';

const LOGO_PLACEHOLDER = '/assets/images/placeholder.png';

class Competition extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    fetchCompetition: PropTypes.func.isRequired,
    competition: CompetitionPropType,
    competitionsLoading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    competition: null,
  };

  componentDidMount() {
    const { competitionId } = this.props.match.params;
    this.props.fetchCompetition(competitionId);
  }

  render() {
    const { locale } = this.props.intl;
    const { competition, competitionsLoading } = this.props;

    if (competitionsLoading) {
      return (
        <div className="HomeCompetition container">
          <Spinner center />
        </div>
      );
    }

    if (!competition) {
      return (
        <div className="HomeCompetition container">
          <p>
            <FormattedMessage
              id="home-competitions-competition-not-found"
              defaultMessage="Kilpailua ei löytynyt"
            />
          </p>
        </div>
      );
    }

    const isUpcoming =
      !competition.is_archived &&
      competition.is_web_closed === null &&
      competition.is_pdf_closed === null;

    const isStarted =
      !competition.is_archived &&
      (competition.is_web_closed === false ||
        competition.is_pdf_closed === false);

    const isEnded =
      !competition.is_archived &&
      competition.is_web_closed === true &&
      competition.is_pdf_closed === true;

    const isArchived = competition.is_archived;

    return (
      <div className="HomeCompetition container">
        <div className="row">
          <div className="col-auto">
            <img
              src={competition.logo ? competition.logoURL() : LOGO_PLACEHOLDER}
              alt={competition.name}
              className="HomeCompetition-logo"
            />
          </div>

          <div className="col-auto">
            <div className="HomeCompetition-title">
              <h3 className="mb-0">{competition.name}</h3>
            </div>
          </div>

          <div className="col-auto ml-auto">
            <div className="HomeCompetition-status d-flex align-items-center">
              <div
                className={classNames(
                  'HomeCompetition-status-icon',
                  'd-flex',
                  'align-items-center',
                  'mr-3',
                  {
                    'text-primary': isStarted,
                    'text-muted': isArchived,
                  }
                )}
              >
                {isUpcoming && <i className="far fa-calendar" />}
                {isStarted && <i className="fas fa-stopwatch" />}
                {isEnded && <i className="far fa-stop-circle" />}
                {isArchived && <i className="fas fa-archive" />}
              </div>

              <div className="HomeCompetition-status-text">
                {isUpcoming && (
                  <FormattedMessage
                    id="home-competition-status-upcoming"
                    defaultMessage="Tulossa"
                  />
                )}

                {isStarted && (
                  <FormattedMessage
                    id="home-competition-status-started"
                    defaultMessage="Käynnissä"
                  />
                )}

                {isEnded && (
                  <FormattedMessage
                    id="home-competition-status-ended"
                    defaultMessage="Päättynyt"
                  />
                )}

                {isArchived && (
                  <FormattedMessage
                    id="home-competition-status-archived"
                    defaultMessage="Arkistoitu"
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-auto">
            <div style={{ width: '100px' }} />
          </div>

          <div className="col">
            <div className="markdown">
              <Markdown source={competition.description[locale]} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    competitions: competitionsSelectors.competitions(state),
    competitionsLoading: competitionsSelectors.loading(state),
  }),
  dispatch =>
    bindActionCreators(
      {
        fetchCompetition: competitionsActions.fetch,
      },
      dispatch
    ),
  (state, dispatch, props) => ({
    ...state,
    competition: state.competitions.find(
      c => c.id === props.match.params.competitionId
    ),
    ...dispatch,
    ...props,
  })
)(injectIntl(Competition));
